var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1306,
    height: 1335,
    viewBox: "0 0 1306 1335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M833.42 603.047V473.033",
    stroke: "white",
    strokeWidth: 6.75884,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3427 231.181L124.476 176.42",
    stroke: "white",
    strokeWidth: 1.35177,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7285 272.856L113.705 263.739",
    stroke: "white",
    strokeWidth: 1.35177,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M527.72 775.283L835.923 599.726",
    stroke: "white",
    strokeWidth: 6.75884,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M481.918 403.705V273.69",
    stroke: "white",
    strokeWidth: 6.75884,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5729 281.858L28.5729 12.9424",
    stroke: "white",
    strokeWidth: 2.8761,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.217 575.939L484.435 400.382",
    stroke: "white",
    strokeWidth: 6.75884,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3427 193.562L124.476 138.801",
    stroke: "white",
    strokeWidth: 1.35177,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3427 156.778L124.476 102.017",
    stroke: "white",
    strokeWidth: 1.35177,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3427 119.861L124.476 65.0996",
    stroke: "white",
    strokeWidth: 1.35177,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7145 222.207L165.834 294.714",
    stroke: "white",
    strokeWidth: 1.35177,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0164 161.768L155.84 203.802",
    stroke: "white",
    strokeWidth: 1.35177,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6145 122.363L47.2826 146.508",
    stroke: "white",
    strokeWidth: 1.35177,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M814.569 989.781L1233.29 1238.35",
    stroke: "white",
    strokeWidth: 6.75884,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M791.315 1001.42L1210.03 1249.98",
    stroke: "white",
    strokeWidth: 6.75884,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3151 294.714C21.2542 294.714 15.5164 289.034 15.4733 282.002C15.4301 274.97 21.1248 269.246 28.1856 269.203C35.419 269.174 41.2719 274.941 41.2 282.031C41.1137 289.063 35.3759 294.714 28.3151 294.714Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M835.91 483.3C828.849 483.3 823.111 477.62 823.068 470.588C823.025 463.556 828.719 457.832 835.78 457.789C843.014 457.76 848.867 463.527 848.795 470.617C848.708 477.649 842.97 483.3 835.91 483.3Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M484.407 283.972C477.347 283.972 471.609 278.292 471.566 271.26C471.523 264.228 477.217 258.504 484.278 258.461C491.511 258.432 497.364 264.199 497.292 271.288C497.206 278.32 491.468 283.972 484.407 283.972Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5582 17.2566C23.8222 17.2566 19.9736 13.4143 19.9446 8.65752C19.9157 3.90079 23.7354 0.0292549 28.4714 7.24596e-05C33.3231 -0.0193825 37.2489 3.88132 37.2006 8.67697C37.1428 13.4337 33.2942 17.2566 28.5582 17.2566Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M124.463 67.8177C121.414 67.8177 118.926 65.3587 118.912 62.31C118.897 59.2757 121.356 56.7879 124.405 56.7735C127.54 56.7591 130.071 59.2613 130.028 62.3244C129.999 65.373 127.511 67.8177 124.448 67.8177H124.463Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.463 107.438C121.414 107.438 118.926 104.979 118.912 101.93C118.897 98.8958 121.356 96.408 124.405 96.3936C127.54 96.3792 130.071 98.8814 130.028 101.944C129.999 104.993 127.511 107.438 124.448 107.438H124.463Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M124.463 144.324C121.414 144.324 118.926 141.865 118.912 138.816C118.897 135.782 121.356 133.294 124.405 133.279C127.54 133.265 130.071 135.767 130.028 138.83C129.999 141.879 127.511 144.324 124.448 144.324H124.463Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124.463 181.942C121.414 181.942 118.926 179.483 118.912 176.434C118.897 173.4 121.356 170.912 124.405 170.898C127.54 170.883 130.071 173.385 130.028 176.448C129.999 179.497 127.511 181.942 124.448 181.942H124.463Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.548 300.222C162.499 300.222 160.012 297.763 159.997 294.714C159.983 291.68 162.442 289.192 165.491 289.178C168.626 289.163 171.157 291.666 171.113 294.729C171.085 297.777 168.597 300.222 165.534 300.222H165.548Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.265 209.323C154.217 209.323 151.729 206.864 151.714 203.815C151.7 200.781 154.159 198.293 157.208 198.278C160.343 198.264 162.874 200.766 162.831 203.829C162.802 206.878 160.314 209.323 157.251 209.323H157.265Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55094 127.885C2.50227 127.885 0.0144433 125.426 6.27521e-05 122.377C-0.0143178 119.343 2.44475 116.855 5.49342 116.841C8.62837 116.827 11.1593 119.329 11.1162 122.392C11.0874 125.44 8.59961 127.885 5.53657 127.885H5.55094Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7155 278.363C94.6668 278.363 92.179 275.904 92.1646 272.855C92.1502 269.821 94.6093 267.333 97.658 267.318C100.793 267.304 103.324 269.806 103.281 272.869C103.252 275.918 100.764 278.363 97.7011 278.363H97.7155Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M423.821 1060.97C416.76 1060.97 411.023 1055.28 410.979 1048.25C410.936 1041.22 416.631 1035.5 423.692 1035.45C430.925 1035.43 436.778 1041.19 436.706 1048.28C436.62 1055.31 430.882 1060.97 423.821 1060.97Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M423.85 1050.28V1223.75L853.568 965.033L28.3427 487.198V285.626",
    stroke: "white",
    strokeWidth: 6.75884,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.47 1304.51C1127.27 1304.51 1084.81 1261.7 1084.51 1208.78C1084.2 1155.86 1126.34 1112.72 1178.57 1112.45C1232.11 1112.17 1275.42 1155.63 1274.82 1208.98C1274.21 1261.98 1231.75 1304.53 1179.47 1304.51Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 19.1548,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.82 1225.67H1048.67V1187.8H1077.82",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.56 1149.39L1072.17 1128.57L1099.21 1102.08L1119.61 1122.9",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.95 1108.28V1079.13H1195.82V1108.28",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1276.64 1225.67H1305.79V1187.8H1276.64",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.9 1149.39L1282.29 1128.57L1255.24 1102.08L1234.85 1122.9",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.82 1188.45H1048.67V1226.31H1077.82",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.56 1264.72L1072.17 1285.56L1099.21 1312.05L1119.61 1291.21",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.95 1305.85V1335H1195.82V1305.85",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1276.64 1188.45H1305.79V1226.31H1276.64",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.9 1264.72L1282.29 1285.56L1255.24 1312.05L1234.85 1291.21",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.63 1279.98C1219.13 1279.98 1251.14 1247.96 1251.14 1208.47C1251.14 1168.97 1219.13 1136.95 1179.63 1136.95C1140.13 1136.95 1108.12 1168.97 1108.12 1208.47C1108.12 1247.96 1140.13 1279.98 1179.63 1279.98Z",
    fill: "#716558",
    stroke: "white",
    strokeWidth: 2.20022,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.f8dff879976845bfb85823b758137437.svg";
export { ForwardRef as ReactComponent };